import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/auth-guard.service';
import { LoginComponent } from './login/login.component';
import { MessengerComponent } from './messenger/messenger.component';

const default_path = 'network';

const routes: Routes = [
  {path: '', redirectTo: default_path, pathMatch: 'full'},
  {path: 'redirectToRoot', redirectTo: default_path, pathMatch: 'full'},
  {path: 'login', component: LoginComponent, pathMatch: 'full'},
  {path: 'network', loadChildren: './network/network.module#NetworkModule', canActivate: [AuthGuard]},
  {path: 'settings', loadChildren: './settings/settings.module#SettingsModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'earnings', loadChildren: './earnings/earnings.module#EarningsModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'community', loadChildren: './community/community.module#CommunityModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'payments', loadChildren: './payments/payments.module#PaymentsModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'yoola', loadChildren: './yoola/yoola.module#YoolaModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'company', loadChildren: './company/company.module#CompanyModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'services', loadChildren: './services/services.module#ServicesModule', canActivate: [AuthGuard], canLoad: [AuthGuard]},
  {path: 'legal', loadChildren: './legal/legal.module#LegalModule', canActivate: [AuthGuard]},
  {path: 'applications', loadChildren: './applications/applications.module#ApplicationsModule', canActivate: [AuthGuard]},
  {path: 'hub', loadChildren: './hub/hub.module#HubModule', canActivate: [AuthGuard]},
  {path: 'messenger', component: MessengerComponent, canActivate: [AuthGuard], pathMatch: 'full'},
  {path: '**', redirectTo: default_path}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts